import { Component, OnInit } from '@angular/core';
import { DynamicFormComponent } from '@components/dynamic-form/dynamic-form.component';
import { Router } from '@angular/router';
import { UserService } from '@services/admin/user.service';
import { ToastrService } from 'ngx-toastr';
import { Registry } from '@/registry.service';
import { LoggerService } from '@services/logger.service';
import { OptionSelect } from '@/models/option-select.model';
import { CommissionsSignalmanService } from '@services/data-source-tables/commissions-signalman.service';
import { CommissionsSignalmanModel } from '@/models/tables/commissions-signalman.model';
import { CommissionsSignalmanFormSettings } from '@/form-settings/commissions-signalman-form-settings';

@Component({
  selector: 'app-commission-signalman-form',
  templateUrl: '../../../../../components/dynamic-form/dynamic-form.component.html',
})
export class CommissionSignalmanFormComponent extends DynamicFormComponent implements OnInit {
  private commissionSignalmanTypes: OptionSelect[] = [];

  constructor(
    protected router: Router,
    protected userService: UserService,
    protected commissionsSignalmanService: CommissionsSignalmanService,
    protected toastr: ToastrService,
  ) {
    super(toastr, userService);

    this.setupMeta();
    this.submitButtonVisible = true;
    this.primaryButton = 'Salva';
    this.secondaryBottomButton = 'Chiudi';
  }

  ngOnInit(): void {
    this.form.controls['creator'].setValue(this.userService.getUserName());

    this.commissionsSignalmanService
      .getCommissionSignalmanTypes()
      .subscribe((commissionSignalmanTypes) => {
        for (const commissionSignalmanType of commissionSignalmanTypes) {
          this.commissionSignalmanTypes.push({
            key: commissionSignalmanType,
            value: commissionSignalmanType,
          });
        }

        this.setupMeta();
      });
  }

  onSubmit() {
    let commissionSignalmanModel = <CommissionsSignalmanModel>this.form.getRawValue();

    this.commissionsSignalmanService.saveCommission(commissionSignalmanModel).subscribe({
      next: () => {
        this.toastr.success('Provvigione salvata correttamente!');

        this.closeModalAndRefresh();
      },
      error: (error) => {
        LoggerService.error('saveCommission failed!');
        LoggerService.error(error);

        this.toastr.error(`Errore durante il salvataggio della provvigione.`);

        setTimeout(() => {
          Registry.getInstance().set('saveInProgress', false);
        }, 1000);
      },
      complete: () => {
        LoggerService.log('Request done');

        setTimeout(() => {
          Registry.getInstance().set('saveInProgress', false);
        }, 1000);
      },
    });
  }

  setupMeta(): void {
    this.meta = CommissionsSignalmanFormSettings.set(
      'commissionSignalmanTypes',
      this.commissionSignalmanTypes,
    )
      .getMeta()
      .sort((a: any, b: any) => a.order - b.order);
  }

  bottomButtonAction() {
    if (this.data.id) {
      Registry.getInstance().get('ButtonDetailCommissionSignalmanComponent').close();
    } else {
      Registry.getInstance().get('ButtonNewCommissionSignalmanComponent').close();
    }
  }

  protected closeModalAndRefresh() {
    if (this.data.id) {
      Registry.getInstance().get('ButtonDetailCommissionSignalmanComponent').close();
    } else {
      Registry.getInstance().get('ButtonNewCommissionSignalmanComponent').close();
    }

    Registry.getInstance().get('CommissionSignalmanComponent').loadCommissions();
  }
}
